function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import Provider from "./BaseProvider";
import isFunction from "lodash/isFunction";
import options from "../../apiV2/ProviderOptions";
var StoreProvider = /*#__PURE__*/ function(Provider) {
    "use strict";
    _inherits(StoreProvider, Provider);
    var _super = _createSuper(StoreProvider);
    function StoreProvider() {
        _classCallCheck(this, StoreProvider);
        var _this;
        _this = _super.apply(this, arguments);
        // Set a Getter Function to return Data
        _defineProperty(_assertThisInitialized(_this), "setDataGetter", function(getDataFunc) {
            _this._getData = !!getDataFunc && isFunction(getDataFunc) ? getDataFunc : _this._getData;
        });
        _defineProperty(_assertThisInitialized(_this), "setKeyVal", function() {
            console.log("No setter set");
            return false;
        });
        return _this;
    }
    _createClass(StoreProvider, [
        {
            // When there is a new listener subscribed
            key: "onSubscribed",
            value: function onSubscribed(uid, channel) {
            // This Provider does not send messages automatically, just action -> reaction
            }
        },
        {
            // When an extension sends data
            key: "onMessageReceived",
            value: function onMessageReceived(uid, channel, msgId, data) {
                switch(msgId){
                    case "set":
                        var setData = this.setKeyVal(data.key, data.value);
                        if (setData && !setData.hasOwnProperty("error")) {
                            this.publish(uid, "store", "onSet", {
                                status: "success",
                                data: setData
                            });
                        } else {
                            this.publish(uid, "store", "error", {
                                status: "error",
                                data: setData
                            });
                        }
                        break;
                    case "get":
                        var _data = this._getData(data || options(uid));
                        if (_data && !_data.hasOwnProperty("error")) {
                            this.publish(uid, "store", "get", _data);
                        } else {
                            this.publish(uid, "store", "error", _data);
                        }
                        break;
                    case "delete":
                        var del = this.deletekey(data);
                        if (del && del.hasOwnProperty("error")) {
                            this.publish(uid, "store", "error", del);
                        }
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "dispatch",
            value: function dispatch() {
            // We need no dispatch
            }
        },
        {
            key: "getData",
            value: function getData() {
                console.log("No getter set");
                return {};
            }
        },
        {
            key: "deletekey",
            value: function deletekey() {
                console.log("No delete Fn set");
                return {};
            }
        }
    ]);
    return StoreProvider;
}(Provider);
_defineProperty(StoreProvider, "providedChannels", [
    "store"
]);
var _StoreProvider = new StoreProvider();
export default _StoreProvider;
